<template>
	<div>
		<TypographyParagraph v-if="lead" class="chart-description-text">
			{{ lead }}
		</TypographyParagraph>
		<dl class="brdcm-status-help">
			<div
				v-for="item in items"
				:key="item.key"
				class="brdcm-status-help__item"
			>
				<dt class="brdcm-status-help__term">
					<span
						class="brdcm-status-help__swatch"
						:style="{ backgroundColor: item.color }"
					/>
					<span class="brdcm-status-help__label">{{ item.label }}</span>
				</dt>
				<dd class="brdcm-status-help__text">{{ item.text }}</dd>
			</div>
		</dl>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';
import { TypographyParagraph } from 'ant-design-vue';
import { useI18n } from 'vue-i18n';

import { buildBrdcmStatusHelp } from '@/utils/brdcmStatusHelp';
import type { BrdcmStatusHelpKind } from '@/utils/types/brdcmStatusHelpTypes';


export default {
	components: {
		TypographyParagraph,
	},
	props: {
		kind: {
			type: String as PropType<BrdcmStatusHelpKind>,
			required: true,
		},
		leadKey: {
			type: String,
			default: '',
		},
	},
	setup(props) {
		const { t } = useI18n();
		const items = computed(() => buildBrdcmStatusHelp(
			props.kind,
			key => t(key),
		));
		const lead = computed(() => props.leadKey ? t(props.leadKey) : '');

		return {
			items,
			lead,
		};
	},
};
</script>

<style scoped>
.brdcm-status-help {
	margin: 8px 0 0;
	display: grid;
	gap: 8px;
}

.brdcm-status-help__item {
	display: grid;
	gap: 2px;
}

.brdcm-status-help__term {
	display: flex;
	align-items: center;
	gap: 8px;
	margin: 0;
	font-weight: 600;
}

.brdcm-status-help__swatch {
	width: 12px;
	height: 12px;
	flex: none;
	border-radius: 2px;
}

.brdcm-status-help__text {
	margin: 0;
	color: rgba(0, 0, 0, 0.65);
}

@media (min-width: 720px) {
	.brdcm-status-help__item {
		grid-template-columns: max-content minmax(0, 1fr);
		column-gap: 16px;
		align-items: baseline;
	}
}
</style>
